export default class Occasion {
    constructor() {
        this._classroom = null;
        this._course = null;
        this._day = null;
        this._endBlock = null;
        this._id = null;
        this._startBlock = null;
        this._weeks = null;
        this._weekArray = [];
    }
    get weekArray() {
        return this._weekArray;
    }
    set weekArray(value) {
        this._weekArray = value;
    }
    get endBlock() {
        return this._endBlock;
    }
    set endBlock(value) {
        this._endBlock = value;
    }
    get classroom() {
        return this._classroom;
    }
    set classroom(value) {
        this._classroom = value;
    }
    get course() {
        return this._course;
    }
    set course(value) {
        this._course = value;
    }
    get day() {
        return this._day;
    }
    set day(value) {
        this._day = value;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get startBlock() {
        return this._startBlock;
    }
    set startBlock(value) {
        this._startBlock = value;
    }
    get weeks() {
        return this._weeks;
    }
    set weeks(value) {
        this._weeks = value;
    }
}
